import type {TFunction} from 'i18next';
import {getIntentConfirmLabelKey} from './agentSchema';
import type {AiAgentPendingProposal} from '../../../redux/aiAgent/aiAgent.type';

/**
 * Names what the confirmation creates. The agent's own wording comes first — it is already in
 * the chat language, so a new intent does not need a translation key of its own.
 */
export function getProposalConfirmLabel(proposal: AiAgentPendingProposal, t: TFunction): string {
    if(proposal.confirmLabel?.trim()) {
        return proposal.confirmLabel.trim();
    }
    return t(proposal.update ? 'proposalConfirmUpdate' : getIntentConfirmLabelKey(proposal.intent));
}
